<template>
    <form>
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center">
            <fieldset class="red-border" style="max-width: 80%; margin: auto;">
                <fieldset class="font-110 rounded-border red-border building-detail">
                    <legend style="font-weight:bold">Dados Cadastrais do Imóvel</legend>
                    <a-descriptions bordered :column="1" size="small">
                        <a-descriptions-item label="Matrícula">{{ props.dados[0]['j01_matric'] }}</a-descriptions-item>
                        <a-descriptions-item label="IDBQL">{{ props.dados[0]['j01_idbql'] }}</a-descriptions-item>
                        <a-descriptions-item label="Setor">{{ props.dados[0]['j34_setor'] }}</a-descriptions-item>
                        <a-descriptions-item label="Quadra">{{ props.dados[0]['j34_quadra'] }}</a-descriptions-item>
                        <a-descriptions-item label="Lote">{{ props.dados[0]['j34_lote'] }}</a-descriptions-item>
                        <a-descriptions-item label="Endereço">{{ props.dados[0]['j14_nome'] }} - {{ numero }}/{{ props.dados[0]['bairro'] }}</a-descriptions-item>
                        <a-descriptions-item label="Proprietário">{{ props.dados[0]['z01_nomecomple'] }}</a-descriptions-item>
                    </a-descriptions>
                </fieldset>
            </fieldset>
        </div>

        <div class="audit-map-wrapper">
            <a-spin :spinning="loadingAuditMap" tip="Carregando mapa de auditoria...">
                <a-alert
                    v-if="auditMapError"
                    type="error"
                    show-icon
                    :message="auditMapError"
                />

                <CompAuditoriaMap
                    v-else-if="auditMapData"
                    :key="props.id"
                    :posic="auditMapData.posic"
                    :zoom_busca="auditMapData.zoom_busca"
                    :geom_lote="auditMapData.geo_lote"
                    :geom_edif="auditMapData.geo_edif"
                    :geom_conf="auditMapData.geo_conf"
                    :camadas_dinamicas_data1="auditMapData.camadas_dinamicas_data1"
                    :camadas_dinamicas_data2="auditMapData.camadas_dinamicas_data2"
                    map-height="80vh"
                />
            </a-spin>
        </div>
    </form>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import CompAuditoriaMap from '../../../Maps/CompAuditoriaMap.vue';

const props = defineProps(['dados', 'dadosGeral', 'edifGeo', 'id', 'bicLote', 'bicEdif', 'cadInf']);
const numero =
    props.dadosGeral?.edificacoes?.[0]?.unidades?.[0]?.numero
    ?? props.dados?.[0]?.z01_numero
    ?? 'S/N'

const auditMapData = ref(null);
const auditMapError = ref('');
const loadingAuditMap = ref(false);

async function loadAuditMapData() {
    if (!props.id) return;

    loadingAuditMap.value = true;
    auditMapError.value = '';
    auditMapData.value = null;

    try {
        auditMapData.value = (await window.axios.get(`/api/map-actions/bic/${props.id}/audit-map`)).data.data;
    } catch (error) {
        auditMapData.value = null;
        auditMapError.value = error.response?.data?.message || 'Nao foi possivel carregar o mapa de auditoria.';
    } finally {
        loadingAuditMap.value = false;
    }
}

onMounted(loadAuditMapData);

watch(() => props.id, loadAuditMapData);
</script>

<style scoped>
body {
    text-align: center;
}

h1 {
    color: green;
}

.audit-map-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.audit-map-wrapper :deep(.ant-spin-nested-loading),
.audit-map-wrapper :deep(.ant-spin-container) {
    width: 100%;
}
</style>
